import IbptService from "@/services/IbptService";

export const ibpt = {
  namespaced: true,
  state: {
    ibpt: {},
  },
  actions: {
    getIbpt({ commit }, payload) {
      return IbptService.GetIbpt(payload).then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postIbpt({ commit }, payload) {
      return IbptService.PostIbpt(payload).then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putIbpt({ commit }, payload) {
      return IbptService.PutIbpt(payload).then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteIbpt({ commit }, payload) {
      return IbptService.DeleteIbpt(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getIbptOData({ commit }, payload) {
      return IbptService.GetIbptOData(payload).then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getVersoesAgrupadas({ commit }) {
      return IbptService.GetVersoesAgrupadas().then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    atualizarTabelaIbpt({ commit }, payload) {
      return IbptService.AtualizarTabelaIbpt(payload).then(
        (ibpt) => {
          return Promise.resolve(ibpt);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default ibpt;
